import { render, staticRenderFns } from "./WorkbenchView.vue?vue&type=template&id=67a6bffc&scoped=true&"
import script from "./WorkbenchView.vue?vue&type=script&lang=js&"
export * from "./WorkbenchView.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchView.vue?vue&type=style&index=0&id=67a6bffc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6bffc",
  null
  
)

export default component.exports